import { IOfferSpendByOfferListTableLang } from '../../../types/lang'

export const offerSpendByOfferListTableLang: IOfferSpendByOfferListTableLang = {
	offer_spend_by_offer_list_table: {
		column_offer_id: 'Offer ID_ru',
		column_offer: 'Offer_ru',
		column_offer_in_group: 'Offer in Group_ru',
		column_country: 'Country_ru',
		column_amount: 'Amount_ru',
		column_date: 'Date_ru',
	}
}